import React, { useEffect } from 'react'
import { usePage } from '@inertiajs/react'
import { toast } from 'sonner'
import parse from 'html-react-parser'

const ToastMessages = () => {
  const { flash } = usePage().props

  useEffect(() => {
    if (flash.success) {
      toast.success(parse(flash.success))
    }
    if (flash.error) {
      toast.error(parse(flash.error))
    }
    if (flash.warning) {
      toast.error(parse(flash.warning))
    }
  }, [flash])

  return (
    <></>
  )
}

export default ToastMessages
